// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__ZQ_eT","colCheckbox":"styles_colCheckbox__Fvd78"};